import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-container.tsx
var LazyContainer = lazy(() => import("./container-CUHSOLUx.js").then((n) => n.n).then((module) => ({ default: module.Container })));
function Container({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "container" }),
		children: /* @__PURE__ */ jsx(LazyContainer, { ...props })
	});
}
function ContainerContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "container" }),
		children: /* @__PURE__ */ jsx(LazyContainer, { ...props })
	});
}
var useContainerContent = () => {
	return useMemo(() => ({ container: { component: ContainerContent } }), []);
};
//#endregion
export { Container, useContainerContent };
